import Icon from '@ant-design/icons'

const SVG = () => (
    <svg
        t='1734493132070'
        class='icon'
        viewBox='0 0 1024 1024'
        version='1.1'
        xmlns='http://www.w3.org/2000/svg'
        p-id='5224'
        fontSize={20}
    >
        <path
            d='M512.213333 938.794667c-235.648 0-426.666667-191.018667-426.666666-426.666667s191.018667-426.666667 426.666666-426.666667 426.666667 191.018667 426.666667 426.666667-191.018667 426.666667-426.666667 426.666667z m-149.333333-341.333334v85.333334h106.666667v85.333333h85.333333v-85.333333h42.666667a106.666667 106.666667 0 1 0 0-213.333334h-170.666667a21.333333 21.333333 0 1 1 0-42.666666h234.666667v-85.333334h-106.666667v-85.333333h-85.333333v85.333333h-42.666667a106.666667 106.666667 0 1 0 0 213.333334h170.666667a21.333333 21.333333 0 0 1 0 42.666666h-234.666667z'
            fill='currentColor'
            p-id='5225'
        ></path>
    </svg>
)

export const CompensationIcon = props => <Icon component={SVG} {...props} />
